import React, { useContext, useState } from "react";
import { UserContext } from "../User/UserContext";
import MicrosoftLogin from "../../Config/microsoft-login/dist";
const LoginWithMicrosoft = () => {
const { Userinfo,msalInstance,loginHandler}=useContext(UserContext)
return ( 
      <>
     {/* <MicrosoftLogin clientId={'9b07ecbd-2df2-4aa2-b77e-681b6aeafb87'}  useLocalStorageCache={true} redirectUri={window.location.origin} postLogoutRedirectUri={window.location.origin}  authCallback={loginHandler} ></MicrosoftLogin> */}
      <MicrosoftLogin tenantUrl="https://login.microsoftonline.com/9b94e12c-00d4-42e3-92e6-4c8f86b256ea" clientId={process.env.REACT_APP_MS_clientid}  useLocalStorageCache={true} redirectUri={window.location.origin} postLogoutRedirectUri={window.location.origin}  authCallback={loginHandler} ></MicrosoftLogin>
      </>
       )
};

export default LoginWithMicrosoft;